function addCommas(nStr){
  nStr += '';
  x = nStr.split('.');
  x1 = x[0];
  x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

function moneyFilter(num){
  var numMoney = num/100;
  numMoney = numMoney.toFixed(2);
  numMoney = addCommas(numMoney);
  return '$' + numMoney;
}

function moneyFilterRaw(num){
  var numMoney = num/100;
  numMoney = numMoney.toFixed(2);
  return numMoney;
}

var quickviewDrawerOpenEvent = new Event("quickviewdrawer:opened");
var quickviewPopoverOpenEvent = new Event("quickviewpopover:opened");

jQuery(document).ready(function($){

  // Open/close Quick Add
  jQuery(document).on("click", ".open-quick-add", function(e) {
    e.preventDefault();
    var handle = jQuery(this).attr('data-product-handle');
    window.location.href = "/products/"+handle;
  });
  /*
  jQuery(document).on('click', '.open-quick-add', function(e){
    e.preventDefault();
    jQuery(this).parents('.quick-add-wrap').find('.open-quick-add').hide();
    jQuery(this).parents('.quick-add-wrap').find('.quick-add').show();
    jQuery(this).parents('.product-item').addClass('variant-open');
  });
  */
  jQuery(document).on('click', '.close-quick-add', function(e){
    e.preventDefault();
    jQuery(this).parents('.quick-add-wrap').find('.open-quick-add').show();
    jQuery(this).parents('.quick-add-wrap').find('.quick-add').hide();
    jQuery(this).parents('.product-item').removeClass('variant-open');
  });


  // Quickview Image change on Variant selection [Desktop View]
  $('body').on('click', 'quick-buy-drawer.drawer--quick-buy product-variants input', function(){
    var thisClickedInput = $(this);
    var productId = thisClickedInput.parents('quick-buy-drawer.drawer--quick-buy').find('.product-form').attr('data-product-id');

    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-product-image').show();
  });

  // Quickview Image change on Variant selection [Mobile View]
  $('body').on('click', 'quick-buy-popover.popover--quick-buy product-variants input', function(){
    var thisClickedInput = $(this);
    var productId = thisClickedInput.parents('quick-buy-popover.popover--quick-buy').find('.product-form').attr('data-product-id');

    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-product-image').show();
  });

  // Quickview Image change on Slider nav click [Desktop View]
  $('body').on('click', 'quick-buy-drawer.drawer--quick-buy .quickview-image-slider-nav .nav-prev', function(){
    var thisClickedNavPrev = $(this);
    var productId = thisClickedNavPrev.parents('quick-buy-drawer.drawer--quick-buy').find('.quick-buy-product').attr('data-product-id');
    var uniqueImageFirstIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-first-index'));
    var uniqueImageCurrentIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index'));
    var uniqueImageLastIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-last-index'));

    var uniqueImagePrevIndex = uniqueImageCurrentIndex - 1;
    if(uniqueImagePrevIndex < uniqueImageFirstIndex){
      uniqueImagePrevIndex = uniqueImageLastIndex;
    }
    
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-slider-img[data-image-index="'+uniqueImagePrevIndex+'"]').show();
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index', uniqueImagePrevIndex);
  });
  $('body').on('click', 'quick-buy-drawer.drawer--quick-buy .quickview-image-slider-nav .nav-next', function(){
    var thisClickedNavNext = $(this);
    var productId = thisClickedNavNext.parents('quick-buy-drawer.drawer--quick-buy').find('.quick-buy-product').attr('data-product-id');
    var uniqueImageFirstIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-first-index'));
    var uniqueImageCurrentIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index'));
    var uniqueImageLastIndex = parseInt($('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-last-index'));

    var uniqueImageNextIndex = uniqueImageCurrentIndex + 1;
    if(uniqueImageNextIndex > uniqueImageLastIndex){
      uniqueImageNextIndex = uniqueImageFirstIndex;
    }
    
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-slider-img[data-image-index="'+uniqueImageNextIndex+'"]').show();
    $('quick-buy-drawer.drawer--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index', uniqueImageNextIndex);
  });

  // Quickview Image change on Slider nav click [Mobile View]
  $('body').on('click', 'quick-buy-popover.popover--quick-buy .quickview-image-slider-nav .nav-prev', function(){
    var thisClickedNavPrev = $(this);
    var productId = thisClickedNavPrev.parents('quick-buy-popover.popover--quick-buy').find('.quick-buy-product').attr('data-product-id');
    var uniqueImageFirstIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-first-index'));
    var uniqueImageCurrentIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index'));
    var uniqueImageLastIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-last-index'));

    var uniqueImagePrevIndex = uniqueImageCurrentIndex - 1;
    if(uniqueImagePrevIndex < uniqueImageFirstIndex){
      uniqueImagePrevIndex = uniqueImageLastIndex;
    }
    
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-slider-img[data-image-index="'+uniqueImagePrevIndex+'"]').show();
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index', uniqueImagePrevIndex);
  });
  $('body').on('click', 'quick-buy-popover.popover--quick-buy .quickview-image-slider-nav .nav-next', function(){
    var thisClickedNavNext = $(this);
    var productId = thisClickedNavNext.parents('quick-buy-popover.popover--quick-buy').find('.quick-buy-product').attr('data-product-id');
    var uniqueImageFirstIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-first-index'));
    var uniqueImageCurrentIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index'));
    var uniqueImageLastIndex = parseInt($('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-last-index'));

    var uniqueImageNextIndex = uniqueImageCurrentIndex + 1;
    if(uniqueImageNextIndex > uniqueImageLastIndex){
      uniqueImageNextIndex = uniqueImageFirstIndex;
    }
    
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quick-buy-product__image').hide();
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] img.quickview-slider-img[data-image-index="'+uniqueImageNextIndex+'"]').show();
    $('quick-buy-popover.popover--quick-buy .quick-buy-product[data-product-id="'+productId+'"] .quickview-image-slider-nav').attr('data-image-current-index', uniqueImageNextIndex);
  });

  $(document).on('quickviewdraweropen', function(){
    setTimeout(function(){
      var productId = $('quick-buy-drawer[open] .quick-buy-product').attr('data-product-id');
      console.log('productId', productId);
      if(productId != null && productId != undefined){
        $(document).trigger('quickviewopenproductidfetched', [productId]);
      }
      document.dispatchEvent(quickviewDrawerOpenEvent);
    }, 1500);
  });

  $(document).on('quickviewpopoveropen', function(){
    setTimeout(function(){
      var productId = $('quick-buy-popover[open] .quick-buy-product').attr('data-product-id');
      console.log('productId', productId);
      document.dispatchEvent(quickviewPopoverOpenEvent);
    }, 1500);
  });

  $(document).on('quickviewopenproductidfetched', function(e, productId){
    var recommendationResponse = {
      status: 'error',
      response: null
    };
    $.ajax({
      url: '/recommendations/products.json?product_id='+productId+'&limit=8&intent=related',
      method: 'GET',
      dataType: 'json',
      async: false,
      success: function(data){
        recommendationResponse.status = 'success';
        recommendationResponse.response = data;
      },
      error: function(err){
        recommendationResponse.status = 'error';
        recommendationResponse.response = data;
      }
    });
    
    if(recommendationResponse.status == 'success' && recommendationResponse.response.products != null && recommendationResponse.response.products != undefined && recommendationResponse.response.products.length > 0){
      var html = '';
      $.each(recommendationResponse.response.products, function(recProdIdx, product){
        if(product.available === true){
          html += '<product-item class="product-item ">';
          html += '  <div class="product-item__image-wrapper ">';
          html += '    <a href="/products/'+product.handle+'" class="product-item__aspect-ratio aspect-ratio " style="padding-bottom: 100.0%; --aspect-ratio: 1.0">';
          html += '      <img class="product-item__primary-image" loading="lazy" sizes="(max-width: 740px) 65px, 92px" height="1200" width="1200" alt="'+product.title+'" src="'+product.featured_image+'" >';
          html += '    </a>';
          html += '  </div>';
          html += '  <div class="product-item__info  text--small">';
          html += '    <div class="product-item-meta">';
          html += '      <a class="product-item-meta__vendor heading heading--xsmall" href="/collections/vendors?q='+product.vendor+'">'+product.vendor+'</a>';
          html += '      <a href="/products/'+product.handle+'" class="product-item-meta__title">'+product.title+'</a>';
          html += '      <div class="product-item-meta__price-list-container">';
          html += '        <div class="price-list price-list--centered">';
          if(product.compare_at_price_min > product.price_min){
            html += '       <span class="price price--highlight"><span class="visually-hidden">Sale price</span>' + moneyFilter(product.price_min) + '</span>'
            html += '       <span class="price price--compare"><span class="visually-hidden">Regular price</span>' + moneyFilter(product.compare_at_price_min) + '</span>'
          }else{
            html += '       <span class="price"><span class="visually-hidden">Sale price</span>' + moneyFilter(product.price_min) + '</span>'
          }
          html += '         <span class="compare-at-currency">'+ themeVariables.settings.cartCurrency +'</span>';
          html += '        </div>';
          html += '      </div>';
          html += '    </div>';
          html += '  </div>';
          html += '</product-item>';
        }
      });
      $('quick-buy-drawer[open] quick-buy-drawer-recommendation[data-product-id="'+productId+'"] .quick-buy__recommendations-list').html(html);
      $('quick-buy-drawer[open] quick-buy-drawer-recommendation[data-product-id="'+productId+'"]').show();
    }
  });
 

  // Variant Image Swatch Product Grid Item
  // $('body').on('click', 'input.variant-swatch', function(e){
  //   var thisSwatchInput = $(this);
  //   var variantFeaturedMediaId = thisSwatchInput.attr('data-variant-featured-media');
  //   if(variantFeaturedMediaId != undefined && variantFeaturedMediaId != null){
  //     var productItem = thisSwatchInput.parents('product-item.product-item');
  //     productItem.find('.product-item__image-wrapper img.product-item__primary-image').hide();
  //     productItem.find('.product-item__image-wrapper img.product-item__primary-image[data-media-id="'+variantFeaturedMediaId+'"]').show();
  //   }
  // });
});